import React from "react";
import { Link } from "react-router-dom";

const ProjectsItem = ({ image, title, link, gitLink }) => {
  return (
    <>
      <Link
        to={{
          pathname: `//${link}`,
        }}
        target="_blank"
      >
        <div className="project">
          <div className="proj-img">
            <img src={image} width="100%" alt={title} />
            <div className="proj-title">{title}</div>
          </div>
        </div>
      </Link>
      <Link
        to={{
          pathname: `//${gitLink}`,
        }}
        target="_blank"
      >
        <div className="see-more">
          <div className="tech-link">Technical information</div>
          <img src="/images/icons/gear.png" alt="settings" />
        </div>
      </Link>
    </>
  );
};
export default ProjectsItem;
